import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./TagBubble.module.css";

/**
 * Dark-blue rounded tag badge used to display a single tag label.
 */
export function TagBubble({ label, className }) {
  return (
    <span className={classNames(styles.tagBubble, className)}>{label}</span>
  );
}

TagBubble.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};
